"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPropertyResolutionError = void 0;
exports.resolveCustomProperties = resolveCustomProperties;
exports.resolveCustomPropertyValue = resolveCustomPropertyValue;
const formula_evaluator_1 = require("./formula-evaluator");
const SUPPORTED_UNITS = new Set([
    'px',
    'em',
    'rem',
    '%',
    'vh',
    'vw',
    'ms',
    's',
    'deg',
]);
class CustomPropertyResolutionError extends Error {
    constructor(message) {
        super(message);
        this.name = 'CustomPropertyResolutionError';
    }
}
exports.CustomPropertyResolutionError = CustomPropertyResolutionError;
function resolveCustomProperties(customProperties, context) {
    if (!customProperties)
        return {};
    return Object.fromEntries(Object.entries(customProperties).map(([name, definition]) => [
        name,
        resolveCustomPropertyValue(name, definition, context),
    ]));
}
function resolveCustomPropertyValue(name, definition, context) {
    if (!name.startsWith('--')) {
        throw new CustomPropertyResolutionError(`Custom property "${name}" must start with --`);
    }
    const value = (0, formula_evaluator_1.evaluateFormula)(definition.formula, context);
    if (definition.unit) {
        if (!SUPPORTED_UNITS.has(definition.unit)) {
            throw new CustomPropertyResolutionError(`Unsupported unit "${definition.unit}" for ${name}`);
        }
        if (typeof value !== 'number' || !Number.isFinite(value)) {
            throw new CustomPropertyResolutionError(`Custom property ${name} with unit ${definition.unit} requires a finite number`);
        }
        return `${value}${definition.unit}`;
    }
    if (value === null || value === undefined)
        return '';
    if (typeof value === 'object') {
        throw new CustomPropertyResolutionError(`Custom property ${name} resolved to non-scalar value`);
    }
    return String(value);
}
